import { request } from "../utils/request.js"

export const commoditySnapshot_commodityUsed = (commodityId, args) => request({
    url: 'commoditySnapshot/commodityUsed',
    method: 'GET',
    params: { commodityId },
    showFailMessage: true,
    ...args
})

export const commoditySnapshot_commoditySpecUsed = (commoditySpecId, args) => request({
    url: 'commoditySnapshot/commoditySpecUsed',
    method: 'GET',
    params: { commoditySpecId },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commoditySnapshot.js